module.exports = __webpack_public_path__ + "static/media/banner-amor-de-pai.d387909f.png";